import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ConditionGroupViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ConditionGroupViewPage extends Component<ConditionGroupViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.condition_group.view }}
                pages={{
                    entity: InferenceEntities.condition_group(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}